import { FormState, Select } from '@vtex/admin-ui-form'

import { FormattedMessage, useIntl } from 'react-intl'
import { IntegerInput } from 'ui/components/IntegerInput'
import { GIFT_APPLICATION, GiftKeys } from '../../../typings'
import messages from './messages'
import styles from './styles'

type Props = {
  form: FormState
}

export function GiftQuantityInput(props: Props) {
  const { form } = props

  const { $t } = useIntl()

  return (
    <div className={styles.input}>
      <IntegerInput
        name={GiftKeys.maxQuantity}
        label={$t(messages.quantity)}
        state={form}
        min={1}
      />
      <Select
        name={GiftKeys.application}
        state={form}
        className={styles.select}
      >
        <option value={GIFT_APPLICATION.PER_CART}>
          <FormattedMessage {...messages.application.perCart} />
        </option>
        <option value={GIFT_APPLICATION.PER_ITEM}>
          <FormattedMessage {...messages.application.perItem} />
        </option>
      </Select>
    </div>
  )
}
